import * as moment from 'moment';
import qs from 'qs';
import { getLocale } from '../../utils/pathHelper';

const DATE_FORMAT_UPPER = 'YYYY-MM-DD'; // moment用
export const DEFAULT_ADULTS = '2';
export const DEFAULT_CHILDREN = '0';
const DEFAULT_ROOMS = [{ adults: DEFAULT_ADULTS }];

export function getSearchParams() {
  const query = location.search.replace('\?', '');
  const params = qs.parse(query);

  console.log(params);

  if (!params.checkin_date || !params.checkout_date || !params.rooms) {
    return getDefaultSearchParams();
  }

  return params;
}

export function getYadoBackendHost() {
  const $ = (window as any).jQuery;
  if ($('#js-yado-backend-host').length === 0) {
    console.error('#js-yado-backend-host not found!');
  }
  const host = $('#js-yado-backend-host').attr('data-yado-backend-host');
  return host;
}

export function removeShadowGlobalHeader() {
    const $ = (window as any).jQuery;
  if ($('#global-site-header').length === 0) return;

  $('#global-site-header').addClass('shadow-none');
}

export function validateSearchParams(searchParams) {
  if (searchParams) {
    const todayStr = moment().hour(0).minute(0).seconds(0).format(DATE_FORMAT_UPPER);
    const tomorrowStr = moment().add(1, 'days').hour(0).minute(0).seconds(0).format(DATE_FORMAT_UPPER);

    const { rooms, checkin_date, checkout_date } = searchParams;

    if (!rooms && !checkin_date && !checkout_date) {
      // パラメータなしなのでOK
      return true;
    }
    if ((checkin_date && !checkout_date) || (!checkin_date && checkout_date)) {
      console.warn('checkin_date or checkout_date is not found.');
      return false;
    }
    if (!validateDate(searchParams.checkin_date) || !validateDate(searchParams.checkout_date)) {
      console.warn('checkin_date or checkout_date is not valid.');
      return false;
    }

    if (!searchParams.rooms) {
      console.warn('rooms is not found.');
      return false;
    }

    if ( // チェックイン日が今日より前の日、またはチェックアウト日が明日より前の日の場合
      moment(searchParams.checkin_date).isBefore(todayStr) ||
      moment(searchParams.checkout_date).isBefore(tomorrowStr)
    ) {
      console.warn('checkin_date is before today or checkout_date is before tomorrow.');
      return false;
    }

    // チェックイン日とチェックアウト日が同じ場合
    if (moment(searchParams.checkin_date).isSame(searchParams.checkout_date)) {
      console.warn('checkout_date and checkin_date is same.');
      return false;
    }

    // チェックアウト日がチェックイン日より前の場合
    if (moment(searchParams.checkout_date).isBefore(searchParams.checkin_date)) {
      console.warn('checkout_date is before checkin_date.');
      return false;
    }

    // チェックイン日とチェックアウト日の差分日数が10日以上の場合
    const diffDays = moment(searchParams.checkout_date).diff(searchParams.checkin_date, 'days');
    if (diffDays >= 10) {
      console.warn('diff of checkout_date and checkin_date is 10 days over.');
      return false;
    }
    return true;
  }
  return true;
}

export function existsSearchParams(searchParams): boolean {
  return searchParams.checkin_date && searchParams.checkout_date && searchParams.rooms;
}

export function formatRooms(searchParams) {
  let rooms;
  if (searchParams && searchParams.rooms) {
    rooms = [].concat(searchParams.rooms);
    rooms.forEach((room, index) => {
      if (!room.children || room.children === "0") {
        delete room.children;
        delete room.child_ages;
      }
    });
  }
  if (!searchParams || (searchParams && !searchParams.rooms)) {
    rooms = DEFAULT_ROOMS;
  }

  return rooms;
}

export function countStayDays(checkinDate, checkoutDate) {
  if (!checkinDate || !checkoutDate) return null;
  const checkinDateMoment = moment(checkinDate);
  const checkoutDateMoment = moment(checkoutDate);
  const stayDays = checkoutDateMoment.diff(checkinDateMoment, 'days');
  return stayDays;
}

export function formatCheckinCheckoutDates(searchParams): { checkinDate?: string, checkoutDate?: string } {
  const dates: { checkinDate?: string, checkoutDate?: string } = {};
  if (!searchParams || !searchParams.checkin_date || !searchParams.checkout_date) {
    dates.checkinDate = getDefaultCheckinDateString();
    dates.checkoutDate = getDefaultCheckoutDateString();
  }

  if (searchParams && searchParams.checkin_date && searchParams.checkout_date) {
    dates.checkinDate = searchParams.checkin_date;
    dates.checkoutDate = searchParams.checkout_date;
  }
  return dates;
}

export function getDefaultSearchParams() {
  const dates = formatCheckinCheckoutDates(null);
  const rooms = formatRooms(null);
  const resortCode = getResortCode(location.href);
  const params = {
    resort_code: resortCode,
    checkin_date: dates.checkinDate,
    checkout_date: dates.checkoutDate,
    rooms: rooms,
    checkin_time: undefined,
  }
  return params;
}

export function markdownLinkToAHref(str: string) {
  const markdownLinkRegex = /\[(.+?)\]\((https?:\/\/.+?)\)/g
  return str.replace(markdownLinkRegex, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
}

export function getDefaultCheckinDateMoment() {
  const twentyDaysAfter = moment().add(20, 'days');
  const march5th = '2019-03-05';
  if (twentyDaysAfter.isBefore(march5th)) {
    return moment(march5th);
  }
  return twentyDaysAfter;
}

export function getDefaultCheckoutDateMoment() {
  const twentyOneDaysAfter = moment().add(21, 'days');
  const march6th = '2019-03-06';
  if (twentyOneDaysAfter.isBefore(march6th)) {
    return moment(march6th)
  }
  return twentyOneDaysAfter;
}

export function getDefaultCheckinDate() {
  return getDefaultCheckinDateMoment().toDate();
}

export function getDefaultCheckoutDate() {
  return getDefaultCheckoutDateMoment().toDate();
}

export function getDefaultCheckinDateString() {
  return getDefaultCheckinDateMoment().format(DATE_FORMAT_UPPER);
}

export function getDefaultCheckoutDateString() {
  return getDefaultCheckoutDateMoment().format(DATE_FORMAT_UPPER);
}

export function fixRoomsParam(paramStr) {
  return paramStr.replace(/rooms%5B\d+%5D/g, 'rooms[]');
}

export function reloadPageWithoutSearchParams() {
  let illegalUrl = location.href
  let urlWithoutAllParams = illegalUrl.replace(/\?.*/g, '');

  const resortCode = getResortCode(illegalUrl);

  if (resortCode) {
    let correctUrlWithoutSearchParams = `${urlWithoutAllParams}?resort_code=${resortCode}`;
    location.href = correctUrlWithoutSearchParams;
    return;
  }

  return;
}

export function getResortCode(url: string) {
  let resortCodeMatch = url.match(/\/resorts\/([a-zA-Z0-9-]+)\/accommodations/) || url.match(/resort_code=([a-zA-Z0-9-]+)/);

  if (resortCodeMatch && resortCodeMatch.length >= 2) {
    let resortCode = resortCodeMatch[1];
    return resortCode;
  }
  return null;
}

export function countPeople(rooms = []) {
  let peopleCount = 0;
  rooms.forEach((room, index) => {
    peopleCount += Number(room.adults);
    peopleCount += Number((room.child_ages || []).length);
  });
  return peopleCount;
}

export function countAdults(rooms = []) {
  let adultsCount = 0;
  rooms.forEach((room, index) => {
    adultsCount += Number(room.adults);
  });
  return adultsCount;
}

export function countChildren(rooms = []) {
  let childrenCount = 0;
  rooms.forEach((room, index) => {
    childrenCount += Number((room.child_ages || []).length);
  });
  return childrenCount;
}

export function countRooms(rooms = []) {
  if (rooms && rooms.length >= 1) {
    return rooms.length
  }
  return 0;
}

export function setMomentLocale() {
  moment.locale(getLocale());
}

function validateDate(dateStr) {
  return moment(dateStr, DATE_FORMAT_UPPER, true).isValid();
}

export function extractRoomIdFromRoomPlanId(roomPlanId) {
  const roomId = roomPlanId.replace(/_.+/, '').replace(/L.+/, '');
  return roomId;
}

export function makeRoomName(room) {
  if (room.name) {
    return room.name;
  }

  let roomGradeDisplayName = null;
  if (room.grade) {
    roomGradeDisplayName = getRoomGradeName(room.grade);
  }

  let roomTypeDisplayName = null;
  if (room.type) {
    roomTypeDisplayName = getRoomTypeName(room.type);
  }
  let smokingDisplayName = null;
  if (room.smoking) {
    smokingDisplayName = getTranslatedSmokingRoom();
  } else if (room.smoking === false) {
    smokingDisplayName = getTranslatedNonSmokingRoom();
  }

  return [roomGradeDisplayName, roomTypeDisplayName, smokingDisplayName].filter(t => t).join(' ');
}

export function getCancellationLabel(n: number) {
  if (n <= -1) {
    return '';
  }
  if (n === 0) {
    return getTranslatedCancellationOnTheDay();
  }
  return getTranslatedCancellationXDaysBefore(n.toString());
}

export function makeCancellationValueByType(value: number, type: string) {
  switch(type) {
    case 'percent': {
      return `${value.toString()}%`
    }
    case 'amount': {
      return `JPY ${value.toString()}`
    }
    default: {
      console.error(`unexpected cancellation type ${type}!!`);
      return '';
    }
  }
}

export function isImageJalanNoPhoto(imageUrl: string) {
  return imageUrl != null && imageUrl.includes('no_photo');
}

export function boolStrToBool(boolStr: string) {
  if (typeof boolStr === 'string') {
    return boolStr.toLowerCase() === "true";
  }
  return false;
}

export function getBedTypeName(bedType: string) {
  switch(bedType) {
    case 'single': {
      return getTranslatedBedTypeSingle();
    }
    case 'double': {
      return getTranslatedBedTypeDouble();
    }
    case 'semi_double': {
      return getTranslatedBedTypeSemiDouble();
    }
    case 'queen': {
      return getTranslatedBedTypeQueen();
    }
    case 'king': {
      return getTranslatedBedTypeKing();
    }
    case 'futon': {
      return getTranslatedBedTypeFuton();
    }
    case 'extra': {
      return getTranslatedBedTypeExtra();
    }
    default: {
      console.error(`unexpected bed type ${bedType}!!`);
      return '';
    }
  }
}

export function getRoomGradeName(roomGrade: string) {
  switch(roomGrade) {
    case 'standard': {
      return getTranslatedRoomGradeStandard();
    }
    case 'regular': {
      return getTranslatedRoomGradeStandard(); // regularはstandardにする
    }
    case 'economy': {
      return getTranslatedRoomGradeEconomy();
    }
    case 'superior': {
      return getTranslatedRoomGradeSuperior();
    }
    case 'deluxe': {
      return getTranslatedRoomGradeDeluxe();
    }
    case 'special': {
      return getTranslatedRoomGradeSpecial();
    }
    default: {
      console.error(`unexpected room grade ${roomGrade}!!`);
      return '';
    }
  }
}

export function getRoomTypeName(roomType) {
  switch(roomType) {
    case 'single': {
      return getTranslatedSingleRoom();
    }
    case 'twin': {
      return getTranslatedTwinRoom();
    }
    case 'double': {
      return getTranslatedDoubleRoom();
    }
    case 'triple': {
      return getTranslatedTripleRoom();
    }
    case 'four_bed': {
      return getTranslatedFourBedRoom();
    }
    case 'japanese_style_room': {
      return getTranslatedJapaneseStyleRoom();
    }
    case 'japanese_western_style_room': {
      return getTranslatedJapaneseWesternStyleRoom();
    }
    case 'semi_double': {
      return getTranslatedSemiDoubleRoom();
    }
    case 'other': {
      return getTranslatedOthersRoom();
    }
    default: {
      console.error(`unexpected room type ${roomType}!!`);
      return '';
    }
  }
}

export function simpleFormat(str: string) {
  const simpleFormatRe1 = /\r\n?/g;
  const simpleFormatRe2 = /\n\n+/g;
  const simpleFormatRe3 = /([^\n]\n)(?=[^\n])/g;

  let fstr = str.replace(simpleFormatRe1, "\n") // \r\n and \r -> \n
  fstr = fstr.replace(simpleFormatRe2, "<br /><br />") // 2+ newline  -> br br
  fstr = fstr.replace(simpleFormatRe3, "$1<br />") // 1 newline   -> br
  fstr = "<p>" + fstr + "</p>";
  return fstr;
}

export function getTranslatedAdult() {
  const $ = (window as any).jQuery;
  return $('#t-adult').attr('data-t-adult');
}

export function getTranslatedChild() {
  const $ = (window as any).jQuery;
  return $('#t-child').attr('data-t-child');
}

export function getTranslatedPeopleCount() {
  const $ = (window as any).jQuery;
  return $('#t-people-count').attr('data-t-people-count');
}

export function getTranslatedChildAge(age: number) {
  const $ = (window as any).jQuery;
  return $('#t-child-x-age').attr('data-t-child-x-age').replace('%x', age);
}

export function getTranslatedSmokingRoom() {
  const $ = (window as any).jQuery;
  return $('#t-smoking-room').attr('data-t-smoking-room');
}

export function getTranslatedNonSmokingRoom() {
  const $ = (window as any).jQuery;
  return $('#t-non-smoking-room').attr('data-t-non-smoking-room');
}

export function getTranslatedDoubleRoom() {
  const $ = (window as any).jQuery;
  return $('#t-double-room').attr('data-t-double-room');
}

export function getTranslatedFourBedRoom() {
  const $ = (window as any).jQuery;
  return $('#t-four-bed-room').attr('data-t-four-bed-room');
}

export function getTranslatedOthersRoom() {
  const $ = (window as any).jQuery;
  return $('#t-others-room').attr('data-t-others-room');
}

export function getTranslatedSemiDoubleRoom() {
  const $ = (window as any).jQuery;
  return $('#t-semi-double-room').attr('data-t-semi-double-room');
}

export function getTranslatedSingleRoom() {
  const $ = (window as any).jQuery;
  return $('#t-single-room').attr('data-t-single-room');
}

export function getTranslatedTripleRoom() {
  const $ = (window as any).jQuery;
  return $('#t-triple-room').attr('data-t-triple-room');
}

export function getTranslatedTwinRoom() {
  const $ = (window as any).jQuery;
  return $('#t-twin-room').attr('data-t-twin-room');
}

export function getTranslatedJapaneseStyleRoom() {
  const $ = (window as any).jQuery;
  return $('#t-japanese-style-room').attr('data-t-japanese-style-room');
}

export function getTranslatedJapaneseWesternStyleRoom() {
  const $ = (window as any).jQuery;
  return $('#t-japanese-western-style-room').attr('data-t-japanese-western-style-room');
}

export function getTranslatedRoomGradeStandard() {
  const $ = (window as any).jQuery;
  return $('#t-room-grade-standard').attr('data-t-room-grade-standard');
}

export function getTranslatedRoomGradeEconomy() {
  const $ = (window as any).jQuery;
  return $('#t-room-grade-economy').attr('data-t-room-grade-economy');
}

export function getTranslatedRoomGradeSuperior() {
  const $ = (window as any).jQuery;
  return $('#t-room-grade-superior').attr('data-t-room-grade-superior');
}

export function getTranslatedRoomGradeDeluxe() {
  const $ = (window as any).jQuery;
  return $('#t-room-grade-deluxe').attr('data-t-room-grade-deluxe');
}

export function getTranslatedRoomGradeSpecial() {
  const $ = (window as any).jQuery;
  return $('#t-room-grade-special').attr('data-t-room-grade-special');
}

export function getTranslatedBedTypeSingle() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-single').attr('data-t-bed-type-single');
}

export function getTranslatedBedTypeDouble() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-double').attr('data-t-bed-type-double');
}

export function getTranslatedBedTypeSemiDouble() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-semi-double').attr('data-t-bed-type-semi-double');
}

export function getTranslatedBedTypeQueen() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-queen').attr('data-t-bed-type-queen');
}

export function getTranslatedBedTypeKing() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-king').attr('data-t-bed-type-king');
}

export function getTranslatedBedTypeFuton() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-futon').attr('data-t-bed-type-futon');
}

export function getTranslatedBedTypeExtra() {
  const $ = (window as any).jQuery;
  return $('#t-bed-type-extra').attr('data-t-bed-type-extra');
}

export function getTranslatedCancellationNoShow() {
  const $ = (window as any).jQuery;
  return $('#t-cancellation-no-show').attr('data-t-cancellation-no-show');
}

export function getTranslatedCancellationXDaysBefore(x: string) {
  const $ = (window as any).jQuery;
  return $('#t-cancellation-x-days-before').attr('data-t-cancellation-x-days-before').replace('%day', x);;
}

export function getTranslatedCancellationOnTheDay() {
  const $ = (window as any).jQuery;
  return $('#t-cancellation-on-the-day').attr('data-t-cancellation-on-the-day');
}

export function getTranslatedCheckin() {
  const $ = (window as any).jQuery;
  return $('#t-checkin').attr('data-t-checkin');
}

export function getTranslatedCheckout() {
  const $ = (window as any).jQuery;
  return $('#t-checkout').attr('data-t-checkout');
}

export function getTranslatedChildAges() {
  const $ = (window as any).jQuery;
  return $('#t-child-ages').attr('data-t-child-ages');
}

export function getTranslatedChildAgeLte12() {
  const $ = (window as any).jQuery;
  return $('#t-child-age-lte-12').attr('data-t-child-age-lte-12');
}

export function getTranslatedLiftTicket() {
  const $ = (window as any).jQuery;
  return $('#t-lift-ticket').attr('data-t-lift-ticket');
}

export function getTranslatedRental() {
  const $ = (window as any).jQuery;
  return $('#t-rental').attr('data-t-rental');
}

export function getTranslatedSkiRental() {
  const $ = (window as any).jQuery;
  return $('#t-ski-rental').attr('data-t-ski-rental');
}

export function getTranslatedDirectBus() {
  const $ = (window as any).jQuery;
  return $('#t-direct-bus').attr('data-t-direct-bus');
}

export function getTranslatedHaveBreakfast() {
  const $ = (window as any).jQuery;
  return $('#t-have-breakfast').attr('data-t-have-breakfast');
}

export function getTranslatedHaveDinner() {
  const $ = (window as any).jQuery;
  return $('#t-have-dinner').attr('data-t-have-dinner');
}

export function getTranslatedHaveOpenAirBath() {
  const $ = (window as any).jQuery;
  return $('#t-have-open-air-bath').attr('data-t-have-open-air-bath');
}

export function getTranslatedXNights(x) {
  const $ = (window as any).jQuery;
  const translatedXNights = $('#t-x-nights').attr('data-t-x-nights');
  return translatedXNights.replace('%x', x);
}

export function getTranslatedXPeople(x) {
  const $ = (window as any).jQuery;
  const translatedXPeople = $('#t-number-of-people-other').attr('data-t-number-of-people-other');
  return translatedXPeople.replace('%count', x);
}

export function getTranslatedMale() {
  const $ = (window as any).jQuery;
  return $('#t-male').attr('data-t-male');
}

export function getTranslatedFemale() {
  const $ = (window as any).jQuery;
  return $('#t-female').attr('data-t-female');
}

export function getTranslatedOnePerson() {
  const $ = (window as any).jQuery;
  const translatedOnePerson = $('#t-number-of-people-one').attr('data-t-number-of-people-one');
  if (translatedOnePerson == null) {
    return getTranslatedXPeople(1);
  }
  return translatedOnePerson;
}
